<div class="bg-white">
	<div class="border-bottom p-4">
		<h3 class="pt-2">Bill Limits</h3>
	</div>

	<div class="p-4">
		<div class="page-1 w-100">
			<form class="row" *ngIf="formGroup" [formGroup]="formGroup">
				<div class="mb-3">
					<div class="form-group">
						<div class="row">
							<div class="col-md-4">
								<label>Daily Transactions Limit</label>
								<input type="number" [formControl]="getFormControl('daliyLimit')"
									class="form-control" />
								<small class="text-danger" *ngIf="formValidator.formErrors.daliyLimit">
									{{ formValidator.formErrors.daliyLimit }}
								</small>
							</div>

							<div class="col-md-4">
								<label>Transaction Amount Limit</label>
								<input type="number" [formControl]="getFormControl('amountLimit')"
									class="form-control" />
								<small class="text-danger" *ngIf="formValidator.formErrors.amountLimit">
									{{ formValidator.formErrors.amountLimit }}
								</small>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>

	<div class="border-top p-4">
		<div class="ms-auto col-auto">
			<button (click)="submit()" class="btn btn-primary">Update</button>
		</div>
	</div>
</div>
